mainApp.component('maintenancePlanUpgradePhases', {
    templateUrl: '/public/components/configuration/maintenancePlan/maintenance-plan-upgrade-phases.component.html',
    bindings: {
        model: '<',
        errors: '<',
        changeListener: '&',
        accountId: '<',
        socketsStatus: '<',
    },
    controller: maintenancePlanPhasesController
});

function maintenancePlanPhasesController($scope, $rootScope, GeneralUtilsService, MaintenanceWindowService, $timeout){
    const ctrl = this;

    const MAX_NUM_OF_PHASES = 10;
    const POSTPONE_TO_MAKE_CHANGES = "The first phase in the maintenance plan will start in less than 48 hours, making changes now might cause inconsistencies. To make changes please postpone the whole plan by one week.";
    const DEFAULT_DELETE_TOOLTIP = "Delete phase";
    const DEFAULT_ADD_TOOLTIP = "Add phase";
    const DEFAULT_EDIT_TOOLTIP = "Edit phase";
    const CANT_DELETE_DEFAULT_PHASE = "Can't delete default phase";
    const CANT_DELETE_PHASE_WITH_SITES = "Can't delete maintenance phase with sites, move all sites to delete phase";
    const CANT_ADD_MAX_NUMBER_OF_PHASES = "Max 10 phases";

    ctrl.$onInit = function() {
        ctrl.selectedPhase = {};
        ctrl.isNewPhase = false;
        ctrl.maxNumberOfPhases = MAX_NUM_OF_PHASES;
        ctrl.postponToMakeChanges = POSTPONE_TO_MAKE_CHANGES;
        ctrl.deleteTooltip = DEFAULT_DELETE_TOOLTIP;
        ctrl.addTooltip = DEFAULT_ADD_TOOLTIP;
        ctrl.editTooltip = DEFAULT_EDIT_TOOLTIP;
    }

    ctrl.addItem = function () {
        if (!ctrl.model.isPlanNotEditable){
            updateAddTooltip();
            if(ctrl.isValidAdd()){
                var newItem = {
                    id: GeneralUtilsService.getRandomId(),
                    name: null,
                    numberOfSites: 0,
                    socketsStatus: {total: 0, success: 0, fail: 0, pending: 0, started: 0, skip: 0},
                    maintenanceWindow: MaintenanceWindowService.getDefaultWindow(),
                };

                ctrl.selectedPhase = newItem;
                ctrl.isNewPhase = true;
                $rootScope.openPopup('phaseEditor');
            }
        }else{
            $rootScope.alert(ctrl.postponToMakeChanges);
        }
    }

    ctrl.changeAction = function (item) {
        if (!ctrl.model.isPlanNotEditable){
            ctrl.selectedPhase = item;

            updateDeleteTooltip(item);

            let htmlID = "inline-actions-" + item.id + "-action";

            //the invoker is in a timeout, to let frontend changes to set place and then invoke the popup
            $timeout(function() {
                $rootScope.$emit("$openPopup", "inline-actions", htmlID , {topMod: 40, leftMod: -140, simplePosition: true, rightArrow: true});
            }, 1);
        }else{
            $rootScope.alert(ctrl.postponToMakeChanges);
        }
    }

    ctrl.editPhase = function (item) {
        ctrl.isNewPhase = false;
        $rootScope.closePopup("inline-actions");
        ctrl.openPopup();
    }

    ctrl.openPopup = function () {
        $rootScope.openPopup('phaseEditor');
    }

    ctrl.isValidDelete = function(){
        let isDefaultDeleted = ctrl.selectedPhase.isDefault;
        let containSites = ctrl.selectedPhase.numberOfSites > 0;

        return !(isDefaultDeleted || containSites);
    }

    ctrl.deletePhase = function(){
        let isValid = ctrl.isValidDelete(ctrl.selectedPhase);
        if(isValid){
            ctrl.selectedPhase.isDeleted = true;
            ctrl.model.phasesToDelete.push(ctrl.selectedPhase.id);

            Object.keys( ctrl.model.siteIdToPhaseIdMap).forEach(key => {
                if(ctrl.model.siteIdToPhaseIdMap[key] === ctrl.selectedPhase.id){
                    delete ctrl.model.siteIdToPhaseIdMap[key];
                }
            })

            $rootScope.closePopup("inline-actions");
        }
    }

    ctrl.isValidAdd = function(){
        return (ctrl.model.maintenancePhases.length  - ctrl.model.phasesToDelete.length) < ctrl.maxNumberOfPhases;
    }

    let updateDeleteTooltip = function(item){
        let deleteTooltip = (item.numberOfSites > 0) ? CANT_DELETE_PHASE_WITH_SITES : DEFAULT_DELETE_TOOLTIP
        deleteTooltip = (item.isDefault) ? CANT_DELETE_DEFAULT_PHASE : deleteTooltip;
        $('.maintenance-plan-wrapper .inline-actions .delete').attr('data-original-title', deleteTooltip);
    }

    let updateAddTooltip = function(){
        let addTooltip = (ctrl.model.maintenancePhases.length - ctrl.model.phasesToDelete.length < 10) ? DEFAULT_ADD_TOOLTIP : CANT_ADD_MAX_NUMBER_OF_PHASES;
        $('.maintenance-plan-wrapper .btn-group .btn-right').attr('data-original-title', addTooltip);
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
        ctrl.original = angular.copy(ctrl.model);
    });
};
